module.exports = __webpack_public_path__ + "static/media/blueblob.d29ee603.svg";